<app-nav-header></app-nav-header>
<div class="wrapper">
    <div class="main">
        <div id="claimPage">
            <h1>{{ 'footer.privacyPolicy.title' | translate }}</h1>
            <p>
                {{ 'footer.privacyPolicy.welcomeMessage' | translate }}
            </p>
            <ol>
                <li>{{ 'footer.privacyPolicy.cookiePolicy' | translate }}</li>
                <li>
                    {{
                        'footer.privacyPolicy.dataCollectionPolicy' | translate
                    }}
                </li>
                <li>
                    {{
                        'footer.privacyPolicy.browserRecommendation' | translate
                    }}
                </li>
            </ol>
        </div>
    </div>
</div>
<app-footer></app-footer>
